import { useCallback } from 'react';
import styles from '../styles.css.js';
export var useMouseEvents = function (_a) {
    var position = _a.position, splitPanelRef = _a.splitPanelRef, setSidePanelWidth = _a.setSidePanelWidth, setBottomPanelHeight = _a.setBottomPanelHeight;
    var onDocumentMouseMove = useCallback(function (event) {
        if (!splitPanelRef || !splitPanelRef.current) {
            return;
        }
        if (position === 'side') {
            var mouseClientX = event.clientX;
            var width = splitPanelRef.current.getBoundingClientRect().right - mouseClientX;
            setSidePanelWidth(width);
        }
        else {
            var mouseClientY = event.clientY;
            var height = splitPanelRef.current.getBoundingClientRect().bottom - mouseClientY;
            setBottomPanelHeight(height);
        }
    }, [position, splitPanelRef, setSidePanelWidth, setBottomPanelHeight]);
    var onDocumentMouseUp = useCallback(function () {
        document.body.classList.remove(styles['resize-active']);
        document.body.classList.remove(styles["resize-" + position]);
        document.removeEventListener('mouseup', onDocumentMouseUp);
        document.removeEventListener('mousemove', onDocumentMouseMove);
    }, [onDocumentMouseMove, position]);
    var onSliderMouseDown = useCallback(function () {
        document.body.classList.add(styles['resize-active']);
        document.body.classList.add(styles["resize-" + position]);
        document.addEventListener('mouseup', onDocumentMouseUp);
        document.addEventListener('mousemove', onDocumentMouseMove);
    }, [onDocumentMouseMove, onDocumentMouseUp, position]);
    return onSliderMouseDown;
};
//# sourceMappingURL=use-mouse-events.js.map